module.exports = {

    type: {
        GENERIC:    1,
        MENTION:    2,
        REPORT:     3,
        TOUR:       4,
        SYSTEM:     5,
        ITEM_LINK:  6
    }
};